import { Http } from '@bizzabo/transport';
import { AxiosInstance } from 'axios';
import config from 'config';
import { getGroupId } from '@bizzabo/entities';

const clientFacing = true;

const transport = new Http({
    baseUrl: config.baseUrl,
});
const client: () => AxiosInstance = () => {
    transport.setTokenCookieName(`${config.authCookieAccess}-${getGroupId()}`);
    transport.setRefreshTokenUrl(`/token/refresh?eventGroupId=${getGroupId()}`);
    return transport.http(clientFacing);
};

export default client;
